import script from "./PropertyTitleDeedMap.vue?vue&type=script&setup=true&lang=js"
export * from "./PropertyTitleDeedMap.vue?vue&type=script&setup=true&lang=js"

import "./PropertyTitleDeedMap.vue?vue&type=style&index=0&id=dff59228&lang=scss"

const __exports__ = script;

export default __exports__